import React, { useState } from 'react';
import { AgUiToolCall } from '../../types/agui';
import { Wrench, CheckCircle2, Loader2, ChevronDown, ChevronRight, Globe, Calculator, Database } from 'lucide-react';

interface ToolExecutionPillProps {
  tool: AgUiToolCall;
}

export const ToolExecutionPill: React.FC<ToolExecutionPillProps> = React.memo(({ tool }) => {
  const [expanded, setExpanded] = useState(false);

  const getToolIcon = (name: string) => {
    if (name.includes('search') || name.includes('market')) {
      return <Globe size={14} className="tool-type-icon text-blue" />;
    }
    if (name.includes('math') || name.includes('pnl') || name.includes('calc')) {
      return <Calculator size={14} className="tool-type-icon text-green" />;
    }
    if (name.includes('portfolio') || name.includes('customer')) {
      return <Database size={14} className="tool-type-icon text-yellow" />;
    }
    return <Wrench size={14} className="tool-type-icon" />;
  };

  return (
    <div className={`tool-pill ${tool.status}`}>
      <button
        type="button"
        className="tool-pill-header"
        onClick={() => setExpanded(!expanded)}
        aria-expanded={expanded}
        aria-label={`${tool.name} tool call, ${tool.status === 'calling' ? 'running' : 'completed'}. Show details`}
      >
        <span className="tool-status-icon">
          {tool.status === 'calling' ? (
            <Loader2 size={14} className="spin text-blue" />
          ) : (
            <CheckCircle2 size={14} className="text-green" />
          )}
        </span>
        {getToolIcon(tool.name)}
        <span className="tool-name">{tool.name}</span>
        <span className="tool-expand-icon">
          {expanded ? <ChevronDown size={14} /> : <ChevronRight size={14} />}
        </span>
      </button>

      {expanded && (
        <div className="tool-pill-body">
          {tool.args && (
            <div className="tool-section">
              <span className="tool-section-label">Inputs:</span>
              <pre className="tool-code">{tool.args}</pre>
            </div>
          )}
          {tool.result && (
            <div className="tool-section">
              <span className="tool-section-label">Result:</span>
              <pre className="tool-code">{typeof tool.result === 'object' ? JSON.stringify(tool.result, null, 2) : String(tool.result)}</pre>
            </div>
          )}
        </div>
      )}
    </div>
  );
});
